import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface EFillingApplication {
    appllicationId: string;
    type: string;
    title: string;
    applicant: string;
    filingDate: string;
    status: string;
    examiner: string;
    lastUpdate: string;
}

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    getApplications(): Observable<any> {
        return of([
            {
                "docId": "PAT-2025-001234",
                "category": "patent",
                "refNumber": "REF-001",
                "statusDate": "10/20/25",
                "status": "Approved",
                "requestSummary": "Solar Energy Converter System",
                "filesCount": 10,
                "invoiceNumber": "INV-001",
                "submittedDate": "9/15/25",
                "submittedBy": "TechCorp Industries"
            },
            {
                "docId": "TM-2025-005678",
                "logoUrl": "https://asean-ipregister.wipo.net/wopublish-search/service/images/0aLPP2osudojqiPv847dDQdmRZXEBvfWYW-dfzRPQNCTMZZoFCmN98PjasDK0jTrXyTBEQv1gvLrt5zpyig6WHPWvvb9pWm_R4XGcngbc0E?noLogo=true&disclaimer=Machine",
                "category": "trademark",
                "refNumber": "REF-002",
                "statusDate": "10/18/25",
                "status": "Under Review",
                "requestSummary": "TechVision Brand Logo",
                "filesCount": 5,
                "invoiceNumber": "INV-002",
                "submittedDate": "9/28/25",
                "submittedBy": "Vision Enterprises"
            },
            {
                "docId": "ID-2025-009876",
                "logoUrl": "https://www.gravatar.com/avatar/05dfd4b41340d09cae045235eb0893c3?d=mp",
                "category": "design",
                "refNumber": "REF-003",
                "statusDate": "10/15/25",
                "status": "Pending",
                "requestSummary": "Ergonomic Office Chair Design",
                "filesCount": 3,
                "invoiceNumber": "INV-003",
                "submittedDate": "10/1/25",
                "submittedBy": "Comfort Designs Ltd"
            },
            {
                "docId": "GI-2025-000234",
                "category": "geographical interface",
                "refNumber": "REF-004",
                "statusDate": "10/10/25",
                "status": "Approved",
                "requestSummary": "Kashmir Saffron License",
                "filesCount": 7,
                "invoiceNumber": "INV-004",
                "submittedDate": "8/20/25",
                "submittedBy": "Kashmir Farmers Association"
            },
            {
                "docId": "PAT-2025-001567",
                "category": "patent",
                "refNumber": "REF-005",
                "statusDate": "10/22/25",
                "status": "Under Review",
                "requestSummary": "AI-Powered Diagnostic Tool",
                "filesCount": 8,
                "invoiceNumber": "INV-005",
                "submittedDate": "10/5/25",
                "submittedBy": "MedTech Solutions"
            },
            {
                "docId": "TM-2025-006789",
                "logoUrl": "https://www.gravatar.com/avatar/05dfd4b41340d09cae045235eb0893c3?d=mp",
                "category": "trademark",
                "refNumber": "REF-006",
                "statusDate": "10/12/25",
                "status": "Objection Raised",
                "requestSummary": "EcoGreen Product Line",
                "filesCount": 4,
                "invoiceNumber": "INV-006",
                "submittedDate": "9/10/25",
                "submittedBy": "Green Solutions Inc"
            },
            {
                "docId": "ID-2025-010234",
                "logoUrl": "https://www.gravatar.com/avatar/05dfd4b41340d09cae045235eb0893c3?d=mp",
                "category": "design",
                "refNumber": "REF-007",
                "statusDate": "10/14/25",
                "status": "Pending",
                "requestSummary": "Smart Watch Interface",
                "filesCount": 2,
                "invoiceNumber": "INV-007",
                "submittedDate": "10/8/25",
                "submittedBy": "Wearable Tech Co"
            },
            {
                "docId": "PAT-2025-002345",
                "category": "patent",
                "refNumber": "REF-008",
                "statusDate": "9/30/25",
                "status": "Rejected",
                "requestSummary": "Biodegradable Packaging Material",
                "filesCount": 6,
                "invoiceNumber": "INV-008",
                "submittedDate": "7/22/25",
                "submittedBy": "Eco Innovations"
            }
        ])
    }
}
